<template>
  <v-autocomplete
    class="autocomplete-limit"
    v-model="selected"
    :items="items"
    :placeholder="$gettext('Select country')"
    item-value="id"
    item-text="name"
    return-object
    outlined
    clearable
    :dense="dense"
    :disabled="disabled"
    hide-details="auto"
    :counter="limit"
    :menu-props="menuProps"
    multiple
    chips
    deletable-chips
    @input="adjustOptions"
    :rules="required ? emptyRules : []"
  >
    <template slot="no-data">
      <translate class="ml-3">No data available</translate>
    </template>
  </v-autocomplete>
</template>
<script>
import Vue from 'vue';
export default {
  props: {
    value: {},
    limit: {
      type: Number,
      default: 3,
    },
    items: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    flag: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
      emptyRules: [(v) => !!v.length || Vue.prototype.$gettext("Field is required")],
      menuProps: {
        disabled: false,
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selected = val;
      },
    },
  },
  methods: {
    async adjustOptions(val) {
      if (val.length >= this.limit) {
        this.menuProps.disabled = true;
      } else {
        this.menuProps.disabled = false;
      }

      this.$emit("input", val);
    },
  },
};
</script>

<style lang="scss">
.autocomplete-limit:not(.v-input--dense) .v-select__selections {
  min-height: 56px !important;
}
</style>